import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SidebarCartComponent } from 'shared/components/shared/sidebar/cart/sidebar-cart.component';
import { ISidebarCartService, ISidebarCartServiceToken } from 'shared/services/ui/sidebar/cart/sidebar-cart-service.interface';

@Component({
  selector: 'app-sidebar-cart',
  templateUrl: './sidebar-cart.component.html',
  standalone: false
})
export class SidebarCartMHComponent extends SidebarCartComponent implements OnInit, OnDestroy {
  public shouldDisplaySidebarShoppingCart: boolean | undefined;
  private sidebarShoppingCartVisibilitySubscription: Subscription | undefined;

  private readonly sidebarCartService: ISidebarCartService = inject(ISidebarCartServiceToken);

  public ngOnInit(): void {
    this.sidebarShoppingCartVisibilitySubscriptionInit();
  }

  public ngOnDestroy(): void {
    this.sidebarShoppingCartVisibilitySubscription?.unsubscribe();
  }

  private sidebarShoppingCartVisibilitySubscriptionInit() {
    if (!this.sidebarShoppingCartVisibilitySubscription) {
      this.sidebarShoppingCartVisibilitySubscription = this.sidebarCartService.sidebarShoppingCartChangedGet().subscribe(
        (sidebarShoppingCartDesiredVisibility) => {
          this.shouldDisplaySidebarShoppingCart = sidebarShoppingCartDesiredVisibility;
        }
      );
    }
  }

}
